// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2712%27 height=%278%27 viewBox=%270 0 12 8%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 1.5L6 6.5L11 1.5%27 stroke=%27%231f2937%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TranslatorPage - Modern DeepL-inspired design with optimized viewport usage */

.translator-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: transparent;
  overflow: hidden;
}

.main-content > .container {
  width: min(1600px, 95vw);
  max-width: none;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

/* Header - Compact */
.header {
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: var(--border-width) solid var(--border-color);
  padding: 1.25rem 0;
  flex-shrink: 0;
  z-index: 100;
  box-shadow: var(--shadow-sm);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 90%;
  margin: 0 auto;
  padding: 0 var(--spacing-lg);
}

.logo {
  font-size: 1.75rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--accent-color) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -1px;
}

.stats-link {
  color: var(--text-secondary);
  text-decoration: none;
  font-size: var(--font-size-base);
  font-weight: 500;
  padding: var(--spacing-xs) var(--spacing-md);
  border-radius: var(--border-radius);
  transition: all 0.2s ease;
}

.stats-link:hover {
  color: var(--accent-color);
  background-color: var(--surface-color);
}

/* Main Content - Takes remaining space */
.main-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 2rem 0 1.5rem;
  min-height: 0;
}

.translator-container {
  max-width: 100%;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0 var(--spacing-lg);
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  min-height: 0;
  flex: 1 1;
}

/* Language Bar */
.language-bar {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  gap: var(--spacing-lg);
  align-items: center;
  padding: 1.5rem 2rem;
  background-color: var(--background-color);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
  transition: box-shadow 0.3s ease;
  flex-shrink: 0;
}

.language-bar:hover {
  box-shadow: var(--shadow-lg);
}

.language-selector {
  position: relative;
}

.language-select {
  width: 100%;
  padding: 1rem 1.5rem;
  background-color: var(--surface-color);
  border: var(--border-width) solid var(--border-color);
  border-radius: var(--border-radius);
  color: var(--text-primary);
  font-size: 1.125rem;
  font-weight: 600;
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 1rem center;
  padding-right: 3rem;
  transition: all 0.2s ease;
}

.language-select:hover {
  border-color: var(--border-hover);
  background-color: var(--background-color);
}

.language-select:focus {
  border-color: var(--accent-color);
  box-shadow: 0 0 0 3px rgba(0, 71, 171, 0.1);
}

.swap-button {
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--accent-color) 0%, var(--accent-hover) 100%);
  border: none;
  border-radius: 50%;
  font-size: 1.5rem;
  color: white;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-md);
  flex-shrink: 0;
}

.swap-button:hover {
  transform: rotate(180deg) scale(1.1);
  box-shadow: var(--shadow-lg);
}

/* Translation Panels - Takes most space with EQUAL heights */
.translation-panels {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  flex: 1 1;
  min-height: 0;
  height: 100%;
  min-height: clamp(420px, 60vh, 720px);
}

.panel {
  background-color: var(--background-color);
  border: var(--border-width) solid var(--border-color);
  border-radius: var(--border-radius-lg);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: var(--shadow-md);
  transition: all 0.3s ease;
  height: 100%;
}

.source-panel,
.target-panel {
  height: 100%;
}

.panel:hover {
  box-shadow: var(--shadow-lg);
  border-color: var(--border-hover);
}

.panel:focus-within {
  border-color: var(--accent-color);
  box-shadow: var(--shadow-lg), 0 0 0 3px rgba(0, 71, 171, 0.1);
}

.text-area {
  flex: 1 1;
  padding: 1.5rem;
  border: none;
  resize: none;
  font-size: 1.125rem;
  line-height: 1.7;
  color: var(--text-primary);
  background-color: transparent;
  overflow-y: auto;
  min-height: 0;
  height: 100%;
}

.text-area::placeholder {
  color: var(--text-muted);
}

.text-area:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.translated-text {
  flex: 1 1;
  display: flex;
  align-items: flex-start;
  color: var(--text-primary);
  white-space: pre-wrap;
  word-wrap: break-word;
  font-weight: 500;
  overflow-y: auto;
  padding: 1.5rem;
  font-size: 1.125rem;
  line-height: 1.7;
  min-height: 0;
  height: 100%;
}

.translated-text .placeholder {
  color: var(--text-muted);
  font-style: italic;
  font-weight: 400;
}

.panel-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1.5rem;
  border-top: var(--border-width) solid var(--border-color);
  background-color: var(--surface-color);
  flex-shrink: 0;
}

.char-count {
  font-size: var(--font-size-base);
  color: var(--text-muted);
  font-weight: 500;
}

.clear-button {
  font-size: var(--font-size-base);
  color: var(--text-secondary);
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: var(--border-radius);
  transition: all 0.2s ease;
}

.clear-button:hover {
  color: var(--accent-color);
  background-color: rgba(0, 71, 171, 0.1);
}

/* Loading State */
.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  color: var(--text-muted);
}

.loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid var(--border-color);
  border-top-color: var(--accent-color);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-bottom: var(--spacing-sm);
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Error Message */
.error-message {
  padding: 1rem 1.5rem;
  background: linear-gradient(135deg, #fee 0%, #fdd 100%);
  border: var(--border-width) solid #fcc;
  border-radius: var(--border-radius);
  color: #c33;
  font-size: var(--font-size-base);
  font-weight: 500;
  box-shadow: var(--shadow-sm);
  flex-shrink: 0;
}

/* Instruction Bar */
.instruction-bar {
  flex-shrink: 0;
}

.instruction-input {
  width: 100%;
  padding: 1rem 1.5rem;
  background-color: var(--background-color);
  border: var(--border-width) solid var(--border-color);
  border-radius: var(--border-radius-lg);
  font-size: 1rem;
  color: var(--text-primary);
  transition: all 0.2s ease;
  box-shadow: var(--shadow-sm);
}

.instruction-input::placeholder {
  color: var(--text-muted);
  font-style: italic;
}

.instruction-input:hover {
  border-color: var(--border-hover);
  box-shadow: var(--shadow-md);
}

.instruction-input:focus {
  outline: none;
  border-color: var(--accent-color);
  background-color: var(--background-color);
  box-shadow: var(--shadow-md), 0 0 0 3px rgba(0, 71, 171, 0.1);
}

.instruction-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: var(--surface-color);
}

/* Action Bar */
.action-bar {
  display: flex;
  justify-content: center;
  flex-shrink: 0;
}

.translate-button {
  padding: 1.125rem 3rem;
  background: linear-gradient(135deg, var(--accent-color) 0%, var(--accent-hover) 100%);
  color: white;
  font-size: 1.125rem;
  font-weight: 600;
  border-radius: var(--border-radius-lg);
  transition: all 0.3s ease;
  min-width: 240px;
  box-shadow: var(--shadow-lg);
  position: relative;
  overflow: hidden;
}

.translate-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
}

.translate-button:hover:not(:disabled)::before {
  left: 100%;
}

.translate-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: var(--shadow-xl);
}

.translate-button:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: var(--shadow-md);
}

.translate-button:disabled {
  background: var(--border-color);
  color: var(--text-muted);
  cursor: not-allowed;
  box-shadow: none;
}

/* Footer */
.footer {
  padding: 1rem 0;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  border-top: var(--border-width) solid var(--border-color);
  flex-shrink: 0;
}

.footer p {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .translator-container {
    max-width: 95%;
  }
}

@media (max-width: 768px) {
  .translator-page {
    height: auto;
    min-height: 100vh;
  }

  .main-content {
    overflow: visible;
    padding: 1rem 0;
  }

  .main-content > .container {
    width: 100%;
  }

  .translator-container {
    padding: 0 0.75rem;
    gap: 1rem;
  }

  .header {
    padding: 0.875rem 0;
  }

  .header-content {
    max-width: 100%;
    padding: 0 1rem;
  }

  .logo {
    font-size: 1.375rem;
  }

  .stats-link {
    font-size: 0.875rem;
    padding: 0.375rem 0.75rem;
  }

  .language-bar {
    grid-template-columns: 1fr;
    gap: 0.75rem;
    padding: 0.875rem 1rem;
  }

  .language-select {
    padding: 0.875rem 1.25rem;
    padding-right: 2.5rem;
    font-size: 1rem;
    background-position: right 0.875rem center;
  }

  .swap-button {
    width: 48px;
    height: 48px;
    font-size: 1.25rem;
    transform: rotate(90deg);
    margin: 0 auto;
  }

  .swap-button:hover {
    transform: rotate(270deg) scale(1.1);
  }

  .translation-panels {
    grid-template-columns: 1fr;
    gap: 1rem;
    height: auto;
    min-height: auto;
  }

  .panel {
    height: auto;
    min-height: 280px;
  }

  .text-area {
    min-height: 180px;
    font-size: 1rem;
    padding: 1rem;
    line-height: 1.6;
  }

  .translated-text {
    font-size: 1rem;
    padding: 1rem;
    line-height: 1.6;
  }

  .panel-footer {
    padding: 0.625rem 1rem;
  }

  .char-count,
  .clear-button {
    font-size: 0.875rem;
  }

  .instruction-input {
    padding: 0.875rem 1.125rem;
    font-size: 0.9375rem;
  }

  .translate-button {
    padding: 1rem 2rem;
    font-size: 1.0625rem;
    min-width: 200px;
    width: 100%;
    max-width: 320px;
  }

  .footer {
    padding: 0.75rem 0;
  }

  .footer p {
    font-size: 0.8125rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/TranslatorPage.css"],"names":[],"mappings":"AAAA,gFAAgF;;AAEhF;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,2CAA2C;EAC3C,2BAA2B;EAC3B,4DAA4D;EAC5D,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sFAAsF;EACtF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,gCAAgC;EAChC,gBAAgB;EAChB,4CAA4C;EAC5C,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA,yCAAyC;AACzC;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,SAAO;AACT;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,yDAAyD;EACzD,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;EACzC,sCAAsC;EACtC,4BAA4B;EAC5B,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,sCAAsC;EACtC,qDAAqD;EACrD,mCAAmC;EACnC,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yDAA6Q;EAC7Q,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qFAAqF;EACrF,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,SAAO;EACP,aAAa;EACb,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;EACzC,qDAAqD;EACrD,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,6DAA6D;AAC/D;;AAEA;EACE,SAAO;EACP,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,0BAA0B;EAC1B,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,yDAAyD;EACzD,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,uDAAuD;EACvD,sCAAsC;EACtC,mCAAmC;EACnC,WAAW;EACX,gCAAgC;EAChC,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,yCAAyC;EACzC,qDAAqD;EACrD,sCAAsC;EACtC,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,yCAAyC;EACzC,6DAA6D;AAC/D;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,qFAAqF;EACrF,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,kBAAkB;EAClB,0CAA0C;EAC1C,2BAA2B;EAC3B,yDAAyD;EACzD,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;IAC1B,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,0CAA0C;EAC5C;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;IACxB,cAAc;EAChB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":["/* TranslatorPage - Modern DeepL-inspired design with optimized viewport usage */\n\n.translator-page {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: transparent;\n  overflow: hidden;\n}\n\n.main-content > .container {\n  width: min(1600px, 95vw);\n  max-width: none;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n}\n\n/* Header - Compact */\n.header {\n  background-color: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-bottom: var(--border-width) solid var(--border-color);\n  padding: 1.25rem 0;\n  flex-shrink: 0;\n  z-index: 100;\n  box-shadow: var(--shadow-sm);\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 90%;\n  margin: 0 auto;\n  padding: 0 var(--spacing-lg);\n}\n\n.logo {\n  font-size: 1.75rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--accent-color) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: -1px;\n}\n\n.stats-link {\n  color: var(--text-secondary);\n  text-decoration: none;\n  font-size: var(--font-size-base);\n  font-weight: 500;\n  padding: var(--spacing-xs) var(--spacing-md);\n  border-radius: var(--border-radius);\n  transition: all 0.2s ease;\n}\n\n.stats-link:hover {\n  color: var(--accent-color);\n  background-color: var(--surface-color);\n}\n\n/* Main Content - Takes remaining space */\n.main-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding: 2rem 0 1.5rem;\n  min-height: 0;\n}\n\n.translator-container {\n  max-width: 100%;\n  width: 100%;\n  height: 100%;\n  margin: 0 auto;\n  padding: 0 var(--spacing-lg);\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  min-height: 0;\n  flex: 1;\n}\n\n/* Language Bar */\n.language-bar {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);\n  gap: var(--spacing-lg);\n  align-items: center;\n  padding: 1.5rem 2rem;\n  background-color: var(--background-color);\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-md);\n  transition: box-shadow 0.3s ease;\n  flex-shrink: 0;\n}\n\n.language-bar:hover {\n  box-shadow: var(--shadow-lg);\n}\n\n.language-selector {\n  position: relative;\n}\n\n.language-select {\n  width: 100%;\n  padding: 1rem 1.5rem;\n  background-color: var(--surface-color);\n  border: var(--border-width) solid var(--border-color);\n  border-radius: var(--border-radius);\n  color: var(--text-primary);\n  font-size: 1.125rem;\n  font-weight: 600;\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L6 6.5L11 1.5' stroke='%231f2937' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 1rem center;\n  padding-right: 3rem;\n  transition: all 0.2s ease;\n}\n\n.language-select:hover {\n  border-color: var(--border-hover);\n  background-color: var(--background-color);\n}\n\n.language-select:focus {\n  border-color: var(--accent-color);\n  box-shadow: 0 0 0 3px rgba(0, 71, 171, 0.1);\n}\n\n.swap-button {\n  width: 56px;\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, var(--accent-color) 0%, var(--accent-hover) 100%);\n  border: none;\n  border-radius: 50%;\n  font-size: 1.5rem;\n  color: white;\n  transition: all 0.3s ease;\n  box-shadow: var(--shadow-md);\n  flex-shrink: 0;\n}\n\n.swap-button:hover {\n  transform: rotate(180deg) scale(1.1);\n  box-shadow: var(--shadow-lg);\n}\n\n/* Translation Panels - Takes most space with EQUAL heights */\n.translation-panels {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n  flex: 1;\n  min-height: 0;\n  height: 100%;\n  min-height: clamp(420px, 60vh, 720px);\n}\n\n.panel {\n  background-color: var(--background-color);\n  border: var(--border-width) solid var(--border-color);\n  border-radius: var(--border-radius-lg);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  box-shadow: var(--shadow-md);\n  transition: all 0.3s ease;\n  height: 100%;\n}\n\n.source-panel,\n.target-panel {\n  height: 100%;\n}\n\n.panel:hover {\n  box-shadow: var(--shadow-lg);\n  border-color: var(--border-hover);\n}\n\n.panel:focus-within {\n  border-color: var(--accent-color);\n  box-shadow: var(--shadow-lg), 0 0 0 3px rgba(0, 71, 171, 0.1);\n}\n\n.text-area {\n  flex: 1;\n  padding: 1.5rem;\n  border: none;\n  resize: none;\n  font-size: 1.125rem;\n  line-height: 1.7;\n  color: var(--text-primary);\n  background-color: transparent;\n  overflow-y: auto;\n  min-height: 0;\n  height: 100%;\n}\n\n.text-area::placeholder {\n  color: var(--text-muted);\n}\n\n.text-area:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.translated-text {\n  flex: 1;\n  display: flex;\n  align-items: flex-start;\n  color: var(--text-primary);\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  font-weight: 500;\n  overflow-y: auto;\n  padding: 1.5rem;\n  font-size: 1.125rem;\n  line-height: 1.7;\n  min-height: 0;\n  height: 100%;\n}\n\n.translated-text .placeholder {\n  color: var(--text-muted);\n  font-style: italic;\n  font-weight: 400;\n}\n\n.panel-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem 1.5rem;\n  border-top: var(--border-width) solid var(--border-color);\n  background-color: var(--surface-color);\n  flex-shrink: 0;\n}\n\n.char-count {\n  font-size: var(--font-size-base);\n  color: var(--text-muted);\n  font-weight: 500;\n}\n\n.clear-button {\n  font-size: var(--font-size-base);\n  color: var(--text-secondary);\n  font-weight: 500;\n  padding: 0.5rem 1rem;\n  border-radius: var(--border-radius);\n  transition: all 0.2s ease;\n}\n\n.clear-button:hover {\n  color: var(--accent-color);\n  background-color: rgba(0, 71, 171, 0.1);\n}\n\n/* Loading State */\n.loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n  color: var(--text-muted);\n}\n\n.loading-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid var(--border-color);\n  border-top-color: var(--accent-color);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  margin-bottom: var(--spacing-sm);\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Error Message */\n.error-message {\n  padding: 1rem 1.5rem;\n  background: linear-gradient(135deg, #fee 0%, #fdd 100%);\n  border: var(--border-width) solid #fcc;\n  border-radius: var(--border-radius);\n  color: #c33;\n  font-size: var(--font-size-base);\n  font-weight: 500;\n  box-shadow: var(--shadow-sm);\n  flex-shrink: 0;\n}\n\n/* Instruction Bar */\n.instruction-bar {\n  flex-shrink: 0;\n}\n\n.instruction-input {\n  width: 100%;\n  padding: 1rem 1.5rem;\n  background-color: var(--background-color);\n  border: var(--border-width) solid var(--border-color);\n  border-radius: var(--border-radius-lg);\n  font-size: 1rem;\n  color: var(--text-primary);\n  transition: all 0.2s ease;\n  box-shadow: var(--shadow-sm);\n}\n\n.instruction-input::placeholder {\n  color: var(--text-muted);\n  font-style: italic;\n}\n\n.instruction-input:hover {\n  border-color: var(--border-hover);\n  box-shadow: var(--shadow-md);\n}\n\n.instruction-input:focus {\n  outline: none;\n  border-color: var(--accent-color);\n  background-color: var(--background-color);\n  box-shadow: var(--shadow-md), 0 0 0 3px rgba(0, 71, 171, 0.1);\n}\n\n.instruction-input:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background-color: var(--surface-color);\n}\n\n/* Action Bar */\n.action-bar {\n  display: flex;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.translate-button {\n  padding: 1.125rem 3rem;\n  background: linear-gradient(135deg, var(--accent-color) 0%, var(--accent-hover) 100%);\n  color: white;\n  font-size: 1.125rem;\n  font-weight: 600;\n  border-radius: var(--border-radius-lg);\n  transition: all 0.3s ease;\n  min-width: 240px;\n  box-shadow: var(--shadow-lg);\n  position: relative;\n  overflow: hidden;\n}\n\n.translate-button::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.5s ease;\n}\n\n.translate-button:hover:not(:disabled)::before {\n  left: 100%;\n}\n\n.translate-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-xl);\n}\n\n.translate-button:active:not(:disabled) {\n  transform: translateY(0);\n  box-shadow: var(--shadow-md);\n}\n\n.translate-button:disabled {\n  background: var(--border-color);\n  color: var(--text-muted);\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n/* Footer */\n.footer {\n  padding: 1rem 0;\n  text-align: center;\n  background-color: rgba(255, 255, 255, 0.8);\n  backdrop-filter: blur(10px);\n  border-top: var(--border-width) solid var(--border-color);\n  flex-shrink: 0;\n}\n\n.footer p {\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .translator-container {\n    max-width: 95%;\n  }\n}\n\n@media (max-width: 768px) {\n  .translator-page {\n    height: auto;\n    min-height: 100vh;\n  }\n\n  .main-content {\n    overflow: visible;\n    padding: 1rem 0;\n  }\n\n  .main-content > .container {\n    width: 100%;\n  }\n\n  .translator-container {\n    padding: 0 0.75rem;\n    gap: 1rem;\n  }\n\n  .header {\n    padding: 0.875rem 0;\n  }\n\n  .header-content {\n    max-width: 100%;\n    padding: 0 1rem;\n  }\n\n  .logo {\n    font-size: 1.375rem;\n  }\n\n  .stats-link {\n    font-size: 0.875rem;\n    padding: 0.375rem 0.75rem;\n  }\n\n  .language-bar {\n    grid-template-columns: 1fr;\n    gap: 0.75rem;\n    padding: 0.875rem 1rem;\n  }\n\n  .language-select {\n    padding: 0.875rem 1.25rem;\n    padding-right: 2.5rem;\n    font-size: 1rem;\n    background-position: right 0.875rem center;\n  }\n\n  .swap-button {\n    width: 48px;\n    height: 48px;\n    font-size: 1.25rem;\n    transform: rotate(90deg);\n    margin: 0 auto;\n  }\n\n  .swap-button:hover {\n    transform: rotate(270deg) scale(1.1);\n  }\n\n  .translation-panels {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n    height: auto;\n    min-height: auto;\n  }\n\n  .panel {\n    height: auto;\n    min-height: 280px;\n  }\n\n  .text-area {\n    min-height: 180px;\n    font-size: 1rem;\n    padding: 1rem;\n    line-height: 1.6;\n  }\n\n  .translated-text {\n    font-size: 1rem;\n    padding: 1rem;\n    line-height: 1.6;\n  }\n\n  .panel-footer {\n    padding: 0.625rem 1rem;\n  }\n\n  .char-count,\n  .clear-button {\n    font-size: 0.875rem;\n  }\n\n  .instruction-input {\n    padding: 0.875rem 1.125rem;\n    font-size: 0.9375rem;\n  }\n\n  .translate-button {\n    padding: 1rem 2rem;\n    font-size: 1.0625rem;\n    min-width: 200px;\n    width: 100%;\n    max-width: 320px;\n  }\n\n  .footer {\n    padding: 0.75rem 0;\n  }\n\n  .footer p {\n    font-size: 0.8125rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
